import styled from 'styled-components';

const MobHeaderWrapper = styled.div`
  display: flex;
  width: 100vw;
  padding: 1rem;
  justify-content: flex-start;
  background-color: #ffffff;
  position: fixed;
  z-index: 10;
  .page-name {
    /* font-weight: bold; */
    font-size: 20px;
    line-height: 24px;
    padding-left: 1rem;
    line-height: 24px;
    font-family: 'DM Sans', sans-serif;
  }
`;

export { MobHeaderWrapper };
